import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useMemo, useState } from 'react';
import { defaultIndentSizes, defaultShiftIndent } from "./constants";
export var useProjectConfigMemo = function useProjectConfigMemo(project) {
  var externalPageDSL = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return useMemo(function () {
    var _project$config, _project$config2;
    return _objectSpread(_objectSpread({}, project), {}, {
      config: _objectSpread(_objectSpread({}, project.config), {}, {
        indents: ((_project$config = project.config) === null || _project$config === void 0 ? void 0 : _project$config.indents) || defaultIndentSizes,
        shiftIndent: ((_project$config2 = project.config) === null || _project$config2 === void 0 ? void 0 : _project$config2.shiftIndent) || defaultShiftIndent
      }),
      externalPageDSL: externalPageDSL
    });
  }, [externalPageDSL, project]);
};
export var useMemoizedExt = function useMemoizedExt() {
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    fn = _useState2[0],
    setFn = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    globalBridge = _useState4[0],
    setGlobalBridge = _useState4[1];
  return useMemo(function () {
    return {
      extendNode: fn,
      setExtendNode: function setExtendNode(value) {
        return setFn(function () {
          return value;
        });
      },
      globalBridge: globalBridge,
      setGlobalBridge: setGlobalBridge
    };
  }, [fn, setFn, globalBridge, setGlobalBridge]);
};